/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface OrderTimeLineDTO
 */
export interface OrderTimeLineDTO {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTimeLineDTO
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTimeLineDTO
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof OrderTimeLineDTO
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof OrderTimeLineDTO
     */
    type: OrderTimeLineDTOTypeEnum;
    /**
     * 
     * @type {any}
     * @memberof OrderTimeLineDTO
     */
    metadata?: any;
}

/**
    * @export
    * @enum {string}
    */
export enum OrderTimeLineDTOTypeEnum {
    OrderStatus = 'orderStatus',
    Reminder = 'reminder',
    Payment = 'payment',
    Shipping = 'shipping',
    Refund = 'refund',
    System = 'system'
}

